import { guardedClient as clientRequest } from '@repo/shared/helpers';
import {
	UsersApiResponse,
	Role,
	Profile,
	profileSchema,
	User,
	userSchema,
	RoleWithTasks,
	UserDataSettings,
	userDataSettingSchema,
} from '@repo/shared/domain';

export const getUsers = async (query?: string) => {
	const { body: users } = await clientRequest.get<undefined, UsersApiResponse>(
		`/api/users${query ? `?${query}` : ''}`,
		{ schema: undefined },
	);
	return users;
};

export const getBlockedCount = async () => {
	const { body } = await clientRequest.get<undefined, { count: number }>('/api/users/blocked-count', {
		schema: undefined,
	});
	return body;
};

export const getInReviewCount = async () => {
	const { body } = await clientRequest.get<undefined, { count: number }>('/api/users/in-review-count', {
		schema: undefined,
	});
	return body;
};

export const getProfile = async (userId: string): Promise<Profile | undefined> => {
	try {
		const { body } = await clientRequest.get<typeof profileSchema, Profile>(`/api/users/${userId}/profile`, {
			schema: profileSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get user profile:', error);
		return undefined;
	}
};

export const getUser = async (userId: string): Promise<User | undefined> => {
	try {
		const { body } = await clientRequest.get<typeof userSchema, User>(`/api/users/${userId}`, {
			schema: userSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get user:', error);
		return undefined;
	}
};

export const getUserRolesWithTasks = async (
	userId: string,
	query?: string,
): Promise<{ data: RoleWithTasks[]; count: number } | undefined> => {
	try {
		const { body } = await clientRequest.get<undefined, { data: RoleWithTasks[]; count: number }>(
			`/api/users/${userId}/roles-with-tasks${query ? `?${query}` : ''}`,
			{ schema: undefined },
		);
		return body;
	} catch (error) {
		console.error('Failed to get user roles with tasks:', error);
		return undefined;
	}
};

export const getUserDataSettings = async (): Promise<UserDataSettings | undefined> => {
	try {
		const { body } = await clientRequest.get('/api/settings/user-data', {
			schema: userDataSettingSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get user data settings:', error);
		return undefined;
	}
};
